import { render, staticRenderFns } from "./addStaffGroup.vue?vue&type=template&id=257af795&"
import script from "./addStaffGroup.vue?vue&type=script&lang=js&"
export * from "./addStaffGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports